export const STICKY_HEADER_HEIGHT = 98;

export const HEADER_HIDE_ZONE = 25;

export const GALLERY_BLOCK_HEIGHT = 434;
